import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';
import { LOANS_STATUS, OFFER_STATUS } from 'constants/offer';

import { isSatisfyOption } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

import type { IOffersState } from '../types';

export const mapOffersWithStatuses = ({
  offers,
  currentStatuses,
  currentBanksWithActiveStatuses,
  activeGroupKey = 'Active',
}: {
  offers: TOffer[];
  currentStatuses: IOffersState['offersStatuses'];
  currentBanksWithActiveStatuses: string[];
  activeGroupKey?: GatewayRanking.TGroupType;
}) => {
  return offers.map((offer) => {
    // если оффер в статусе PreApproved, то НЕ переносим его в activeGroupKey
    if (offer.loansStatus === LOANS_STATUS.PREAPPROVED) {
      return offer;
    }

    if (currentStatuses[offer.id] && !isSatisfyOption(['Active', 'AwaitingCall', 'Refuses'], offer.group)) {
      // если статус уже есть в текущих статусах, а оффер НЕ в activeGroupKey и НЕ в Refuses,
      // то добавляем статус к офферу и переводим в переданную группу activeGroupKey
      return {
        ...offer,
        status: currentStatuses[offer.id],
        group: activeGroupKey,
      };
    }

    // если статус не найден, но банк с активным статусом есть в текущих банках,
    // то добавляем статус ALREADY_SENT_FROM_SAME_BANK,
    // чтобы не показывать кнопку отправки заявки
    if (!currentStatuses[offer.id] && currentBanksWithActiveStatuses.includes(offer.bankId)) {
      return {
        ...offer,
        status: OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK,
      };
    }

    return offer;
  });
};
